export enum Day
{
	Sunday,
	Monday ,
	Tuesday,
	Wednesday,
	Thursday,
	Friday,
	Saturday
}
